import React from 'react';
import _ from 'lodash';

import MultipleAvatars from 'components/MultipleAvatars';
import { getContributorAvatarUrl } from 'common/constants/Avatars';
import Autocomplete from 'components/base/Autocomplete';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';
import { navigateBookDemoClick } from 'common/utils/utils';
import { SPACES } from 'common/constants/sizes';
import { Flex } from 'components/base/layout-components';
import Text from 'components/base/Text';
import { isEqualAllTeams } from './TeamsDropdown';
import useTreeTeamsContributors from './hooks/useTreeTeamsContributors';
import { BookDemoTooltip } from '@linearb/linui-common';
import {
  CTA_TOOLTIP_TEXTS,
  TRACKING as TRACKING_EVENTS
} from '../../../../dashboard/doraV2/dashboard.doraV2.freeTier.consts';
import useDoraFeatureFlags from 'views/root/views/home/hooks/useDoraFeatureFlags';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  popper: {
    width: 'unset !important',
    minWidth: '15rem',
    maxWidth: '25rem'
  }
}));

const ContributorsAutocomplete = props => {
  const {
    selectedContributor,
    globallySelectedTeams,
    onChange,
    isTeamLicense
  } = props;
  const currentContributors = useTreeTeamsContributors({
    teams: isEqualAllTeams(globallySelectedTeams) ? [] : globallySelectedTeams
  });
  const { enableTeamSelection, isAllControbutorsTeamSelected } =
    useDoraFeatureFlags();

  const contributor_name = selectedContributor ? selectedContributor.name : '';
  const contributorsDropdownOptions = [
    { value: '', displayValue: 'All Members', searchableValue: '' },
    ..._.chain(currentContributors)
      .orderBy('name')
      .map((contributor = {}) => ({
        value: contributor,
        searchableValue: contributor.name,
        displayValue: (
          <Flex items='center'>
            <MultipleAvatars
              disableTooltip
              avatars={[{ url: getContributorAvatarUrl(contributor) }]}
            />
            <Text pl={SPACES.small} size='medium' ellipsisAfter>
              {contributor.name}
            </Text>
          </Flex>
        )
      }))
  ];

  const clickAndTrackBookDemo = () => {
    TrackingService.logEvent(TRACKING.EVENTS.CTA_CLICK, {
      page: TRACKING.PAGES.METRICS,
      cta: TRACKING_EVENTS.CTA_TYPE.DROPDOWN,
      intent: TRACKING.CTA_INTENT.BOOK_A_DEMO,
      source_url: window.location.href
    });
    navigateBookDemoClick();
  };

  const bookDemoTooltipProps = {
    message: CTA_TOOLTIP_TEXTS.METRICS_MEMBERS,
    buttonText: CTA_TOOLTIP_TEXTS.BOOK_A_DEMO,
    disabled: !isTeamLicense || !isAllControbutorsTeamSelected,
    onClick: clickAndTrackBookDemo
  };

  const classes = useStyles();

  return (
    <BookDemoTooltip {...bookDemoTooltipProps}>
      <div>
        <Autocomplete
          width='15rem'
          key='MemebersAutocomplete'
          placeholder={
            selectedContributor ? selectedContributor.name : 'All Members'
          }
          options={contributorsDropdownOptions}
          selectedOptionValue={selectedContributor ? selectedContributor : null}
          onChange={contributor => {
            TrackingService.logEvent(TRACKING.EVENTS.FILTER, {
              page: TRACKING.PAGES.METRICS,
              filter_name: TRACKING.FILTER.CONTRIBUTOR,
              contributor_name
            });
            onChange(contributor);
          }}
          data-testid='ContributorsAutocomplete'
          getOptionSelected={(option, value) => option.value.id === value.id}
          dataCy='ContributorsAutocomplete'
          disabled={!enableTeamSelection}
          classes={{
            popper: classes.popper
          }}
        />
      </div>
    </BookDemoTooltip>
  );
};
export default ContributorsAutocomplete;
